<template>
  <div class="text-sm" v-loading="isBusy">
    <MessageControl
      :approved-message-list-url="approvedMessageListUrl"
      v-model="form.message"
      :can-send-approved-sms="canSendApprovedMessage"
      :can-send-sms="canSendMessage"
    >
      <template #attachments>
        <attachment-list
          v-model="form.media"
          class="px-2 w-100"
        ></attachment-list>
      </template>
      <template #bottom-left-tools-after>
        <ToolButton
          :disabled="isAttachMediaButtonDisabled"
          @click="openAttachmentDialog"
          title="Add attachments"
        >
          <i class="fas fa-paperclip fa-fw"></i>
        </ToolButton>
      </template>
      <template #bottom-right-tools>
        <el-dropdown
          :disabled="! canSend"
          @click="send"
          @command="handleSendMenuCommand"
          split-button
          size="medium"
          class="send-button"
          title="Send message"
        >
          <i class="fas fa-paper-plane fa-fw"></i>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item disabled>Schedule message</el-dropdown-item>
              <el-dropdown-item
                command="custom-time"
                divided
                class="mb-2"
              >
                Custom time
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </MessageControl>
  </div>
</template>

<script>
import InputMixin from "../../../mixins/inputs";
import AttachmentList from "../../attachment/attachment-list";
import MessageControl from "../../shared/message-control/control.vue";
import {addQueryParams} from "../../../libs/url";
import {transform, isFilled} from "../../../helpers";
import ToolButton from "../../shared/message-control/button.vue";

export default {
  components: {
    AttachmentList,
    MessageControl,
    ToolButton,
  },

  mixins: [InputMixin],

  props: {
    storeUrl: String,
    conversation: Object,
    storePendingMessageUrl: String,
    pendingMessageIndexUrl: String,
    canSendMessage: {
      type: Boolean,
      default: false,
    },
    styles: Object,
    canSendApprovedMessage: {
      type: Boolean,
      default: false,
    },
    baseApprovedMessageListUrl: String,
    brand: Object,
  },

  data() {
    return {
      form: {
        message: null,
        media: null,
      },
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return Boolean
     */
    hasContent() {
      return _.isObject(this.form.message) && isFilled(this.form.message.text);
    },

    /**
     * @return {Boolean}
     */
    inDoNotContact() {
      return isFilled(_.get(this.conversation, 'do_not_contact'));
    },

    /**
     * @return {boolean}
     */
    canSend() {
      return ! this.inDoNotContact && this.hasContent;
    },

    /**
     * @return {string}
     */
    approvedMessageListUrl() {
      return addQueryParams(this.baseApprovedMessageListUrl, {brand: this.brand.id});
    },

    /**
     * @return {boolean}
     */
    isAttachMediaButtonDisabled() {
      return ! this.canSendMessage;
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    send() {
       if (! this.canSend) {
        return;
      }

      this.isBusy = true;
      axios.post(this.storeUrl, this.getForm())
          .then(this.onMessageStored)
          .catch(this.onStoreError)
          .finally(() => {
            this.isBusy = false;
          });
    },

    /**
     * @return {Object}
     */
    getForm() {
      const {message, media, ...others} = this.form;

      return {
        conversation_id: this.conversation.id,
        content: _.get(message, 'text'),
        approved_message_id: _.get(message, 'id'),
        media: transform(media, val => _.map(val, 'id')),
        ...others,
      };
    },

    /**
     * @return {undefined}
     */
    resetForm() {
      this.form = _.mapValues(this.form, () => null);
    },

    /**
     * @return {undefined}
     */
    onMessageStored({data}) {
      this.$emit('outbound-message-created', data.data);
      this.resetForm();
    },

    /**
     * @return {undefined}
     */
    onStoreError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },

    /**
     * @event show-attachment-dialog
     * @return {undefined}
     */
    openAttachmentDialog() {
      eventBus.$emit('show-attachment-dialog');
    },

    /**
     * @return {undefined}
     */
    clearContent() {
      this.resetForm();
    },

    /**
     * @param command
     */
    handleSendMenuCommand(command) {
      if (command === 'custom-time') {
        this.showScheduleForm();
      }
    },

    /**
     * @event show-schedule-dialog
     * @return {undefined}
     */
    showScheduleForm() {
      eventBus.$emit('show-schedule-dialog', {
        form: this.getForm(),
        component: 'schedule-form',
        conversationId: this.conversation.id
      });
    },
  },
}
</script>
